import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="discount-calculator"
export default class extends Controller {
  static targets = ["collegeInput", "referralInput", "fcpPrice", "fcPrice"]
  static values = {
    discountCodes: Array
  }

  connect() {
    // Set up input listeners
    if (this.hasCollegeInputTarget) {
      this.collegeInputTarget.addEventListener("input", () => this.checkDiscount())
    }
    if (this.hasReferralInputTarget) {
      this.referralInputTarget.addEventListener("input", () => this.checkDiscount())
    }
  }

  checkDiscount() {
    const collegeValue = this.hasCollegeInputTarget ? this.collegeInputTarget.value.toLowerCase() : ""
    const referralValue = this.hasReferralInputTarget ? this.referralInputTarget.value.toLowerCase() : ""

    let noDiscount = true
    let appliedDiscount = 0

    // Check discount codes
    if (this.hasDiscountCodesValue) {
      this.discountCodesValue.forEach(code => {
        const codeName = code.name.toLowerCase()
        if (collegeValue.includes(codeName) || referralValue.includes(codeName)) {
          appliedDiscount = code.value
          noDiscount = false
        }
      })
    }

    // Apply discount
    this.applyDiscount(noDiscount ? 0 : appliedDiscount)
  }

  applyDiscount(amount) {
    const color = amount == 0 ? "#78ce13" : "#4592c9"

    if (this.hasFcpPriceTarget) {
      this.fcpPriceTarget.textContent = "$" + String(1199 - amount)
      this.fcpPriceTarget.style.color = color
    }

    if (this.hasFcPriceTarget) {
      this.fcPriceTarget.textContent = "$" + String(699 - amount)
      this.fcPriceTarget.style.color = color
    }
  }
}
